import $ from 'jquery';

$.DataTable = require('datatables.net')

const NavOptions = (function () {
    var selectAll = async function () {
        $(".selected").prop("checked", true);
        return $("[type='checkbox']:checked").length;
    }

    var DeselectAll = async function () {
        $(".selected").prop("checked", false);
        return $("[type='checkbox']:checked").length;
    }

    const toggleSelectAll = async function (e, orders, setSelectedRows) {
        e.target.active = !e.target.active; // Toggle the active state
        const allRows = document.querySelectorAll('tr[class^="order_id_"]');  // Select all table rows with class 'order_id_*'
        
        if (e.target.active) {
            // Select orders whose ids match those in the table rows
            const selectedRows = orders
                .filter(order => Array.from(allRows).some(row => row.classList.contains(`order_id_${order.id}`))) // Filter orders based on table row classes
                .map(order => order.id);  // Extract their ids
            
            setSelectedRows(selectedRows);
        } else {
            setSelectedRows([]); // Deselect all orders if not active
        }
    };
    


    var CountSelected = async function () {
        return selectedCount;
    }

    var initDataTable = function (tid) {
        $(document).ready(function () {
            $('.oldOrders tfoot th').each(function () {
                var title = $('.oldOrders thead th').eq($(this).index()).text();
                $(this).html('<input type="text" placeholder="Search ' + title + '" />');
            });

            var previousUrl = document.referrer;
            var currentUrl = window.location.href;
            
            var table = $('.allOrders').DataTable({
                "pageLength": 100,
                "bDestroy": true,
                "stateSave": true,
                fixedHeader: true,
                order: [], // Table order is set in backend get_orders_q()
                fixedHeader: true,
                // Saves and loads table state (sorting...) when switching between tabs
                stateSaveCallback: function(settings,data) {
                    localStorage.setItem( 'DataTables_' + tid, JSON.stringify(data) );
                },
                stateLoadCallback: function(settings) {
                return JSON.parse( localStorage.getItem( 'DataTables_' + tid ) )
                }
            }).columns.adjust();
        });
    }
    return {
        selectAll: selectAll,
        DeselectAll: DeselectAll,
        initDataTable: initDataTable,
        CountSelected: CountSelected,
        toggleSelectAll: toggleSelectAll,
    }

})();

export default NavOptions;
